module.exports = __webpack_public_path__ + "493b354b3c2b9651346cd0fdb47081a5.svg";